import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { DataSourcesIcon } from '@/lib';
import { useGetDataSourcesByIdsQuery } from '@/services/dataSources';
import { FC } from 'react';
import { UnifiedProfileItem, UnifiedProfileSection, UnifiedProfileSectionEmptyMessage, UnifiedProfileTile } from '../../common';

type UnifiedProfileDatasourcesSectionProps = {
  datasourceIds: string[];
};

export const UnifiedProfileDatasourcesSection: FC<UnifiedProfileDatasourcesSectionProps> = ({ datasourceIds }) => {
  const workspace = useWorkspace();

  const { data: dataSources, isFetching: isDataSourcesFetching } = useGetDataSourcesByIdsQuery(
    {
      workspaceId: workspace.id,
      datasourceIds,
    },
    {
      skip: !datasourceIds,
    }
  );

  return (
    <UnifiedProfileSection header='userUsedInDatasources' headerIcon={<DataSourcesIcon />}>
      <UnifiedProfileTile className='divide-y divide-gray-200 p-0'>
        <Loadable className='h-full' isLoading={isDataSourcesFetching}>
          {dataSources?.length ? (
            dataSources?.map((dataSource) => (
              <UnifiedProfileItem key={dataSource.id} name={dataSource.name} link={`${RouteConstants.dataSources}/${dataSource.id}`} />
            ))
          ) : (
            <UnifiedProfileSectionEmptyMessage labelKey='userUsedInDatasources_empty' />
          )}
        </Loadable>
      </UnifiedProfileTile>
    </UnifiedProfileSection>
  );
};
